import * as React from "react";
import { Link } from "react-router-dom";
// UI Frameworks
import { Form, Checkbox } from "antd";
import { FormComponentProps } from "antd/lib/form";
// Shared components
import Input from "components/Input";
import Button from "components/Button";
// Hooks and utilities
import useUser from "hooks/useUser";
import { normalizeNumbers } from "helpers/persian";
// Styles
import styles from "./index.module.scss";

interface IProps extends FormComponentProps {
	onSubmit: (data: any) => void;
}

const Login: React.FC<IProps> = props => {
	const { login } = useUser();
	const [isEmail, setIsEmail] = React.useState(false);
	const [iranMobile, setIranMobile] = React.useState(false);
	const [intlMobile, setIntlMobile] = React.useState(false);
	const [loading, setLoading] = React.useState(false);
	const { getFieldDecorator, getFieldValue } = props.form;
	const username: string = getFieldValue("username") || "";

	React.useEffect(() => {
		setIntlMobile(username.startsWith("+98"));
		setIranMobile(username.startsWith("09"));
		setIsEmail(username.indexOf("@") > -1);
	}, [username]);

	function handleSubmit(e: React.FormEvent): void {
		e.preventDefault();
		props.form.validateFields(async (err, values) => {
			if (!err) {
				try {
					setLoading(true);
					await login(values);
					setLoading(false);
					props.onSubmit(values);
				} catch (error) {
					setLoading(false);
				}
			}
		});
	}

	const usernameMaxLength = () => {
		if (iranMobile) return 11;
		if (intlMobile) return 13;
		return 50;
	};

	return (
		<Form className={styles["login"]} onSubmit={handleSubmit}>
			<Form.Item label="نام کاربری (ایمیل / شماره موبایل)">
				{getFieldDecorator("username", {
					normalize: normalizeNumbers,
					rules: [
						{
							...(isEmail && { type: "email" }),
							...(iranMobile && { pattern: new RegExp("^(09)[0-9]{9}$") }),
							...(intlMobile && { pattern: new RegExp("^\\+(989)[0-9]{9}$") }),
							message: isEmail
								? "لطفا ایمیل خود را صحیح وارد نمایید"
								: "لطفا شماره موبایل خود را صحیح وارد نمایید",
						},
						{
							required: true,
							transform: value => (value ? value.trim() : value),
							message: "لطفا نام کاربری خود را وارد نمایید",
						},
					],
				})(<Input className="ltr" maxLength={usernameMaxLength()} />)}
			</Form.Item>
			<Form.Item label="رمز عبور">
				{getFieldDecorator("password", {
					rules: [
						{
							required: true,
							transform: value => (value ? value.trim() : value),
							message: "لطفا رمز عبور را وارد نمایید",
						},
					],
				})(<Input type="password" className="ltr" />)}
			</Form.Item>
			<Form.Item>
				{getFieldDecorator("rememberMe", {
					valuePropName: "checked",
					initialValue: true,
				})(<Checkbox>مرا به خاطر بسپار</Checkbox>)}
				<Link to="/auth/forget" className={styles["login__forget-pass"]}>
					فراموشی رمز عبور
				</Link>
			</Form.Item>
			<Form.Item className="button-center">
				<Button htmlType="submit" primary loading={loading}>
					ورود
				</Button>
				<div className={styles["login__register-btn"]}>
					اگر عضو نیستید <Link to="/auth/register">ثبت نام</Link> کنید !
				</div>
			</Form.Item>
		</Form>
	);
};

export default Form.create<IProps>({ name: "login" })(React.memo(Login));
